import type * as Immutable from 'immutable';
import { createMigration } from './utils';

const FANCY_CAPTION_CLASS_TYPE = 'CanvasFancyCaptionAsset';
const CAPTION_CLASS_TYPE = 'CanvasCaptionAsset';

export const migrationTo9_229 = createMigration({
    migrateVideo(video) {
        return video.withMutations((map) => {
            map.get('sceneGroups', []).forEach(
                (sceneGroup: Immutable.Map<string, unknown>, i: number) => {
                    map.setIn(['sceneGroups', i], this.migrateSceneGroup(sceneGroup));
                },
            );
            map.get('slides').forEach((scene: Immutable.Map<string, unknown>, i: number) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateSceneGroup(sceneGroup) {
        return sceneGroup.withMutations((map) => {
            const captionAsset = map.getIn(['captions', 'asset']) as
                | Immutable.Map<string, unknown>
                | undefined;
            if (!captionAsset) {
                return;
            }

            const classType = captionAsset.get('classType') as string;
            const basePath = ['captions', 'asset'];

            if (classType === FANCY_CAPTION_CLASS_TYPE) {
                if (captionAsset.has('style')) {
                    const style = captionAsset.get('style');
                    map.removeIn([...basePath, 'style']);
                    map.setIn([...basePath, 'normalStyle'], style);
                    map.setIn([...basePath, 'spokenWordStyle'], style);
                }
            } else if (classType === CAPTION_CLASS_TYPE) {
                if (captionAsset.has('style')) {
                    const style = captionAsset.get('style');
                    map.removeIn([...basePath, 'style']);
                    map.setIn([...basePath, 'normalStyle'], style);
                }
            }
        });
    },
    migrateScene(scene) {
        return scene.withMutations((map) => {
            map.get('children', []).forEach(
                (child: Immutable.Map<string, unknown>, cIndex: number) => {
                    const path = ['children', cIndex];
                    const asset = map.getIn(path) as Immutable.Map<string, unknown> | undefined;
                    if (!asset) {
                        return;
                    }

                    const classType = asset.get('classType') as string;

                    if (classType === FANCY_CAPTION_CLASS_TYPE) {
                        if (asset.has('style')) {
                            const style = asset.get('style');
                            map.removeIn([...path, 'style']);
                            map.setIn([...path, 'normalStyle'], style);
                            map.setIn([...path, 'spokenWordStyle'], style);
                        }
                    } else if (classType === CAPTION_CLASS_TYPE) {
                        if (asset.has('style')) {
                            const style = asset.get('style');
                            map.removeIn([...path, 'style']);
                            map.setIn([...path, 'normalStyle'], style);
                        }
                    }
                },
            );

            const textPositionPresets = map.get('textPositionPresets') as
                | Immutable.Map<string, Immutable.List<Immutable.Map<string, unknown>>>
                | undefined;
            if (textPositionPresets) {
                textPositionPresets.forEach(
                    (
                        presetAssets: Immutable.List<Immutable.Map<string, unknown>>,
                        position: string,
                    ) => {
                        if (!presetAssets) {
                            return;
                        }
                        presetAssets.forEach(
                            (asset: Immutable.Map<string, unknown>, aIndex: number) => {
                                const path = ['textPositionPresets', position, aIndex];
                                if (!asset) {
                                    return;
                                }

                                const classType = asset.get('classType') as string;

                                if (classType === FANCY_CAPTION_CLASS_TYPE) {
                                    if (asset.has('style')) {
                                        const style = asset.get('style');
                                        map.removeIn([...path, 'style']);
                                        map.setIn([...path, 'normalStyle'], style);
                                        map.setIn([...path, 'spokenWordStyle'], style);
                                    }
                                } else if (classType === CAPTION_CLASS_TYPE) {
                                    if (asset.has('style')) {
                                        const style = asset.get('style');
                                        map.removeIn([...path, 'style']);
                                        map.setIn([...path, 'normalStyle'], style);
                                    }
                                }
                            },
                        );
                    },
                );
            }
        });
    },
});
